import React from "react";
import styles from "./page7.module.scss";
import rectangle from "../../icons/dots_rec.svg";
import round from "../../icons/round.svg";
import square from "../../icons/dots_grey.svg";
import slide from "../../icons/slide.svg";
import hexagon from "../../icons/hexagon.svg";
import arrow from "../../icons/round_arrow.svg";
import grt from "../../icons/grt.svg";
import { Link, useNavigate } from "react-router-dom";
export default function Page7() {
  const navigate = useNavigate();

  const handleNavigateLogin = () => {
    navigate("/login");
  };

  return (
    <div className={styles.mainwrapper}>
      <div>
        <p className={styles.heading}>Discover How It Work</p>
      </div>
      <div className={styles.mainbox}>
        <div className={styles.leftsec}>
          <div className={styles.dots}>
            <img className={styles.rectangle} src={rectangle} alt="rectangle" />
          </div>
          <div>
            <div>
              <p className={styles.bigheading}>Set up your trading platform</p>
            </div>
            <div>
              <p className={styles.bigpara}>
                Get up and start trading today. We have a robust set of APIs and
                comprehensive documentation so you can spend less time planning
                and more time building cool stuff. Here’s what needs to get
                done:
              </p>
            </div>
            <div className={styles.round}>
              <img src={round} alt="round" className={styles.roundImage} />
              <Link
                className={styles.link}
                //to="/docsv3"
                to="https://wikiconnect.thefirstock.com/"
                target="_blank"
                style={{ fontSize: "16px", fontWeight: 600 }}
                onClick={()=>{
                 // window.open("https://wikiconnect.thefirstock.com/","_blank")
                }}
              >
                Our API reference
              </Link>
            </div>
          </div>
          <div className={styles.dots2}>
            <img className={styles.square} src={square} alt="square" />
          </div>
        </div>
        <hr className={styles.verticaldivider} />
        <div className={styles.rightsec}>
          <div className={styles.first}>
            <div className={styles.seconddiv}>
              <p className={styles.firstheading}>Activate your Account</p>
              <p className={styles.firstpara}>
                Get your Firstock trading account by registering
                <a
                  className={styles.link}
                  href="https://signup.thefirstock.com/"
                  target="_blank"
                  style={{ fontSize: "12px", fontWeight: 600 }}
                >
                  here
                </a>
              </p>
            </div>
            <div className={styles.firstcontainer}>
              <img className={styles.firsticon} src={slide} alt="slide" />
            </div>
          </div>
          <hr className={styles.horizonataldivider} />
          <div className={styles.second}>
            <div className={styles.seconddiv}>
              <p className={styles.firstheading}>
                Set up your API key and Vendor code
              </p>
              <p className={styles.firstpara}>
                Once the account opening has been done, login into
                <a
                  className={styles.link}
                  href=""
                  onClick={handleNavigateLogin}
                  style={{
                    marginRight: "5px",
                    marginLeft: "5px",
                    fontSize: "12px",
                    fontWeight: 600,
                  }}
                >
                  key-generation
                </a>
                and generate a vendor code and API key.
              </p>
            </div>
            <div className={styles.secondcontainer}>
              <img className={styles.secondicon} src={hexagon} alt="hexagon" />
            </div>
          </div>
          <hr className={styles.horizonataldivider} />

          <div className={styles.third}>
            <div className={styles.seconddiv}>
              <p className={styles.firstheading}>Start Trading</p>
              <p className={styles.firstpara}>
                Firstock connect provides ready to use library which can be
                directly plugged into your applications.
              </p>
            </div>
            <div className={styles.thirdcontainer}>
              <img className={styles.thirdicon} src={arrow} alt="arrow" />
            </div>
          </div>
          <hr className={styles.horizonataldivider} />
          <div className={styles.fourth}>
            <div className={styles.seconddiv}>
              <p className={styles.firstheading}>Full endpoint documentation</p>
              <p className={styles.firstpara}>
                {/* <Link
                  className={styles.link}
                  to="/docsv3"
                  target="_blank"
                  style={{ fontSize: "12px", fontWeight: 600, marginLeft: 0 }}
                > */}
                  Our API reference includes code samples in your favorite language or framework.
              </p>
            </div>
            <div className={styles.fourthcontainer}>
              <img className={styles.fourthicon} src={grt} alt="grt" />
            </div>
          </div>
          <hr className={styles.horizonataldivider} />
        </div>
      </div>
    </div>
  );
}
